// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer__iqBzx","actions":"Footer-module__actions__WMoNf","cancel":"Footer-module__cancel__4xsGr","confirm":"Footer-module__confirm__sve-j"};